import { useCallback } from 'react';

import { useSafeNavigation, useSafeRouteParams } from '@sg/garnish';

import { useContactUsHandler } from '../../../../hooks';

export const useOpenChatFromHomeScreen = () => {
  const params = useSafeRouteParams<HomeScreenParams>();
  const navigation = useSafeNavigation();
  const { handleContactUs } = useContactUsHandler('home');

  return useCallback(() => {
    if (!params?.chat) return;

    navigation?.setParams({ chat: false });
    void handleContactUs();
  }, [params?.chat, navigation, handleContactUs]);
};

// ─── Types ───────────────────────────────────────────────────────────────────

type HomeScreenParams = {
  chat?: boolean;
};
